import { FilterSet } from '../entities/FilterSet';
import { IGeneralKeys, IFilterSets } from '../../views/product-filters/IProductFilters';
import { Filter } from '../entities/Filter';
import { FilterPriceRange } from '../entities/FilterPriceRange';

export function createFilterSet(filterSetJson: IFilterSets): FilterSet {
    return new FilterSet(filterSetJson);
}

export function create(filterSetsJson: IFilterSets[]): FilterSet[] {
    return filterSetsJson.map(filterSetJson => new FilterSet(filterSetJson));
}

export function createFilter(filterItemJson: IGeneralKeys, filterSetJson: IFilterSets) {
    if (filterSetJson && filterSetJson.isRange) {
        return new FilterPriceRange(filterItemJson, filterSetJson.key);
    }

    return new Filter(filterItemJson, filterSetJson.key);
}
